import { useState } from 'react';
import { fetchWithAuth } from '../lib/fetchWithAuth';

// Shared "delete account" confirm/execute/success flow used by GardenPage and AddTreePage.
export function useAccountDeletion() {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const executeAccountDeletion = async () => {
        setDeleteLoading(true);
        try {
            const response = await fetchWithAuth('/api/users/delete-account', { method: 'DELETE' });
            if (response.ok) {
                setShowDeleteConfirm(false);
                setShowDeleteSuccess(true);
            } else {
                const data = await response.json();
                alert(data.error || "Failed to complete hard deletion.");
                setShowDeleteConfirm(false);
            }
        } catch (err: any) {
            alert("Server connection error: " + err.message);
            setShowDeleteConfirm(false);
        } finally {
            setDeleteLoading(false);
        }
    };

    return {
        showDeleteConfirm, setShowDeleteConfirm,
        showDeleteSuccess, setShowDeleteSuccess,
        deleteLoading, executeAccountDeletion,
    };
}
